import { AuditLogService } from "@common/client"
import { makeQuery } from "./utils"

export const auditLogsBaseKey = ["audit-log"] as const

export const auditLogsListKey = (
  params: Parameters<typeof AuditLogService.listLogs>[0],
) => [...auditLogsBaseKey, params] as const

export const auditLogsQuery = makeQuery({
  serviceCall: AuditLogService.listLogs,
  queryKey: auditLogsListKey,
})
